import TickerItem from "../TickerItem";
import { createLeagueItem } from "../sports/tickerSportUtils";

/** Renderiza únicamente el bloque `league` del objeto de datos del ticker. */
export default function TickerLeagueContent({ league }) {
  return <TickerItem item={createLeagueItem(league)} />;
}